<template lang="pug">
  .sidebar
    .sidebar__toolbar
      h2.sidebar__title {{ activeItem.title | translate }}
    .sidebar__menu-wrapper
      v-card.sidebar__menu
        .sidebar__menu-item(
          v-for="item in items"
          :key="item.id"
          :class="{ 'sidebar__menu-item--active': isActive(item) }"
          @click="onClick(item)")
          svg.sidebar__menu-item-icon
            use(:xlink:href="`/svg/sprite.svg?v=${Date.now()}#${item.icon}`")
          span {{ item.title | translate }}
</template>

<script>
export default {
  name: 'Sidebar',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    isActive (item) {
      const path = item.path.split('?')[0]
      if (path.startsWith('../')) {
        return this.$route.path.includes(path.substring(3))
      }
      return this.$route.path.includes(path)
    },

    onClick (item) {
      this.$router.push({ path: item.path })
    }
  },

  computed: {
    activeItem () {
      return this.items.find(item => this.isActive(item))
    }
  }
}
</script>
